import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { inputBtnTempUpload } from '../../../actions/fileActions';
import FileInputButton from '../FileInputButton';

const UploadButton = props => {
  const { onPhotoSelect, photoFilePreview, skinBtn, className } = props; // onDelete
  return (
    <div className={`upload-photo ${className}`}>
      <FileInputButton
        inputId="new_photo"
        onSelect={onPhotoSelect}
        types="image/*"
        btnClass={skinBtn ? '' : 'btn btn-xs btn-round btn-primary margin-top margin-bottom'}
        btnText={photoFilePreview && photoFilePreview.busy ? 'Uploading...' : 'Replace'}
        busyOverride
        busy={photoFilePreview && photoFilePreview.busy}
        disabledOverride={false}
        skinBtn={skinBtn}
      />
    </div>
  );
};

UploadButton.propTypes = {
  onPhotoSelect: PropTypes.func.isRequired,
  photoFilePreview: PropTypes.shape({ uuid: PropTypes.string, s3_key: PropTypes.string }),
  skinBtn: PropTypes.shape({}),
  className: PropTypes.string,
};

// const mapDispatchToProps = dispatch => ({
//   onPhotoSelect: (file) => {
//     dispatch(inputBtnTempUpload(file, 'new_photo'));
//   },
// });

const mapStateToProps = state => ({
  photoFilePreview: state.cards.file.filePreview.new_photo,
});

// export default connect(mapStateToProps, mapDispatchToProps)(UploadButton);
export default connect(mapStateToProps)(UploadButton);



// WEBPACK FOOTER //
// ./src/cards/components/common/upload/UploadButton.jsx